import { http } from '../../util/http';

export default class VehicleEngineTypeService {
	static add(body) {
		return http.post('/utils/engine-types', body);
	}

	static update(id, body) {
		return http.patch(`/utils/engine-types/${id}`, body);
	}

	static delete(id) {
		return http.delete(`/utils/engine-types/${id}`);
	}
}
